<template>
  <div class="EditUser">

    <user-breadcrumbs :items="[{text: 'Edit'}]">
    </user-breadcrumbs>

    <!--<user-role-badge :user="user">
    </user-role-badge>-->

    <user-toolbar :user="user">
    </user-toolbar>

    <v-form @submit.prevent="submit({name: 'users'})">
      <user-status-card :user="user"
                        @updated="$emit('updated')">
      </user-status-card>

      <user-form-basic-info :form="form"
                            :user="user">
      </user-form-basic-info>

      <communication-preferences :form="form"
                                 :user="user">
      </communication-preferences>

      <user-permissions :form="form"
                        :user="user">
      </user-permissions>

      <v-card>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy">
            Save
          </v-btn>
          <v-btn :to="{name: 'users'}"
                 :disabled="form.busy">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import metaService from "../../services/metaService";
import store from "../../store";
import UserRoleBadge from "./components/UserRoleBadge";
import UserBreadcrumbs from "./components/UserBreadcrumbs";
import UserToolbar from "./components/UserToolbar";
import {Form} from 'vform';
import moment from 'moment-timezone';
import UserFormBasicInfo from "./components/UserFormBasicInfo";
import userService from "../../services/userService";
import UserStatusCard from "./components/UserStatusCard";
import CommunicationPreferences from "./components/CommunicationPreferences";
import UserPermissions from "./components/UserPermissions";

export default {
  components: {UserPermissions, CommunicationPreferences, UserStatusCard, UserFormBasicInfo, UserToolbar, UserBreadcrumbs, UserRoleBadge},
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  metaInfo() {
    this.$store.commit('setTitle', this.user.name);
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      breadcrumbs: [
        {text: 'Users', exact: true, to: {name: 'users'},},
        {text: 'Show User'}
      ],
      form: userService.initForm(),
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'isAdmin',
      'team',
    ])
  },
  created() {
    this.initializeForm(this.user);
  },
  methods: {
    toggleStatus() {
      if (this.currentUser.id === this.user.id) {
        return;
      }
      if (this.form.status === 'Active') {
        this.form.status = 'Inactive'
        this.submit();
      } else if (this.team.has_seats_available) {
        this.form.status = 'Active';
        this.submit();
      }
    },
    initializeForm(user) {
      userService.initFormForUser(this.form, user);
    },
    async submit(to = null) {
      const {data: user} = await this.form.put(`/api/users/${this.user.id}`)
      await this.$store.dispatch('initStore');
      this.$store.commit('setSuccessMessage', `${user.name} updated.`)

      if (to) {
        this.$router.push(to);
      } else {
        this.$emit('updated');
      }
    }
  }
}
</script>
